<template lang="pug">
  div.classifier.fkko
    e-toolbar(
      :hideAddButton="true"
      :hideRemoveButton="true"
      :showViewPanel="false"
      :showActionsPanel="false"
    )
    FkkoTable(
      :items="items"
      @delete="onDelete"
    )

    router-view

</template>

<script>
import FkkoTable from './components/fkko-table'
import { cadastr } from '@/api/api-endpoints'

export default {
  components: {
    FkkoTable,
  },
  computed: {
    items() {
      return this.$store.getters.readUrlEndpoint(this.getEndpoint(this.$route))
    },
  },
  methods: {
    getEndpoint(route) {
      return cadastr.fkko(route)
    },
    onDelete() {
      const { asyncData } = this.$options
      this.$bar.start()
      asyncData({
        store: this.$store,
        route: this.$route,
        methods: this,
      })
        .then(() => {
          this.$bar.finish()
        })
        .catch(() => {
          this.$bar.finish()
        })
    },
  },
  asyncData({ store, route, fromRoute, methods }) {
    return store.dispatch('updateUrlEndpoint', {
      endpoint: methods.getEndpoint(route, fromRoute),
    })
  },
}
</script>
